import Image from 'global/Image';
import { handleErrorAvatar } from 'utils/general';
import { GroupAvatarContainer, NoGroupAvatar } from './styled';
import {
  DATA_COMPONENT_GROUP_INVITATION_GROUP_AVATAR_IMAGE,
  DATA_COMPONENT_GROUP_INVITATION_GROUP_AVATAR_NOIMAGE,
} from './__tests__/constant';

export interface GroupAvatarProps {
  name: string;
  shortName: string;
  src: string;
}

function GroupAvatar({ name, shortName, src }: GroupAvatarProps) {
  return (
    <GroupAvatarContainer>
      {src === '' ? (
        <NoGroupAvatar
          data-cy={DATA_COMPONENT_GROUP_INVITATION_GROUP_AVATAR_NOIMAGE}
        >
          <i data-username={name}>{shortName}</i>
        </NoGroupAvatar>
      ) : (
        <Image
          data-cy={DATA_COMPONENT_GROUP_INVITATION_GROUP_AVATAR_IMAGE}
          alt={name}
          src={src}
          onError={(e) => handleErrorAvatar(e, name)}
        />
      )}
    </GroupAvatarContainer>
  );
}

export default GroupAvatar;
